import { formatDate, formatDateTime } from './formatters/dates'

export class Format {
    constructor() {
        // this.number = new Numbers();
        this.date = formatDate
        this.dateTime = formatDateTime
    }
}
